import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { selectBenchmarkResults } from "#/features/callstack/model/callstackSlice";
import { useAppSelector } from "#/store/hooks";
import { BenchmarkChart } from "./BenchmarkChart";
const StatChip: React.FC<{
  label: string;
  value: number | undefined;
}> = t0 => {
  const $ = _c(14);
  const {
    label,
    value
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme.palette.action.hover) {
    t1 = {
      display: "inline-flex",
      alignItems: "baseline",
      gap: 0.5,
      px: 1.25,
      py: 0.5,
      borderRadius: 1,
      backgroundColor: theme.palette.action.hover
    };
    $[0] = theme.palette.action.hover;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "text.secondary"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <Typography variant="caption" sx={t2}>{label}</Typography>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontWeight: 600
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== value) {
    t5 = value != null ? `${value.toFixed(2)} ms` : "\u2014";
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Typography variant="caption" sx={t4}>{t5}</Typography>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t6) {
    t7 = <Box sx={t1}>{t3}{t6}</Box>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export const BenchmarkView = () => {
  const $ = _c(24);
  const benchmarkResults = useAppSelector(selectBenchmarkResults);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      xs: 1,
      md: 2
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexWrap: "wrap",
      gap: 1
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = benchmarkResults?.averageTime;
  let t3;
  if ($[2] !== t2) {
    t3 = <StatChip label="Avg" value={t2} />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = benchmarkResults?.medianTime;
  let t5;
  if ($[4] !== t4) {
    t5 = <StatChip label="Med" value={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = benchmarkResults?.p75Time;
  let t7;
  if ($[6] !== t6) {
    t7 = <StatChip label="P75" value={t6} />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = benchmarkResults?.p90Time;
  let t9;
  if ($[8] !== t8) {
    t9 = <StatChip label="P90" value={t8} />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = benchmarkResults?.p95Time;
  let t11;
  if ($[10] !== t10) {
    t11 = <StatChip label="P95" value={t10} />;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = benchmarkResults?.p99Time;
  let t13;
  if ($[12] !== t12) {
    t13 = <StatChip label="P99" value={t12} />;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t11 || $[15] !== t13 || $[16] !== t3 || $[17] !== t5 || $[18] !== t7 || $[19] !== t9) {
    t14 = <Stack direction="row" useFlexGap={true} sx={t1}>{t3}{t5}{t7}{t9}{t11}{t13}</Stack>;
    $[14] = t11;
    $[15] = t13;
    $[16] = t3;
    $[17] = t5;
    $[18] = t7;
    $[19] = t9;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <BenchmarkChart />;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t14) {
    t16 = <Stack spacing={t0}>{t14}{t15}</Stack>;
    $[22] = t14;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  return t16;
};